export default __webpack_public_path__ + "static/media/account_balance.93147313.svg";